export const LaybuyCurrencySymbol = {
  AUD: 'AU$',
  NZD: 'NZ$',
  GBP: '£',
};

export const AfterpayCurrencySymbol = {
  AUD: 'AU$',
  NZD: '$',
  USD: '$',
  CAD: 'C$',
};

export const ClearpayCurrencySymbol = {
  GBP: '£',
};

export const LAYBUY_COUNTRIES = ['GBR', 'AUS', 'NZL'];
export const AFTERPAY_COUNTRIES = ['USA', 'AUS', 'NZL', 'CAN'];
export const CLEARPAY_COUNTRIES = ['GBR'];
